import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastsManager } from 'ng2-toastr';
import { Chapter } from '../../models';
import { AuthService } from '../../service/auth.service';
import { EcomicService } from '../../service/comics/ecomic.service';

@Component({
  selector: 'app-wis-episode-add',
  templateUrl: './wis-episode-add.component.html',
  styleUrls: ['./wis-episode-add.component.css']
})
export class WisEpisodeAddComponent implements OnInit {
  imgurl1: any;
  imgurl2: any;
  WISEpisodeForm: FormGroup;
  loading: boolean = false;
  load: boolean = false;
  publish_date: any;
  series: any;
  Wisseasons: any=[];
  id: any;
  user: any;
  reads: any;
  // variables to hide and show the dropdown to refresh the data to set the exact value
  status: any = true;
  showseason: any = false;
  showseries: any = false;
  chapterno: any = true;
  selectedseason: any;
  chaptererror: any = false;
  thumbnail_image: File;
  cover_image: File;
  thumbnail_image_url: any;
  cover_image_url: any;
  coverimageerror: any = false;
  thumbnailimageerror: any = false;
  singlechapter: any;
  thumbnailimageerror_App: boolean=false;
  thumbnail_image_app: File;
  thumbnail_image_url_app: any;
  constructor(private form: FormBuilder, private router: Router, private afs: AngularFirestore, private comicService: EcomicService,
    private route: ActivatedRoute, private auth: AuthService, public toastr: ToastsManager, vcr: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vcr);
  }

  ngOnInit() {
    this.WISEpisodeForm = this.form.group({
      season_id: ['', [Validators.required]],
      shortstory_title: ['', [Validators.required]],
      shortstory_no: ['SS 1', [Validators.required]],
      story_description: ['', [Validators.required]],
      thumbnail_image:['',[]],
      thumbnail_app:['',[]],
      cover_image:['',[]],
      hits: ['', [Validators.required]],
      seo_url: ['', [Validators.required]],
      seo_title: ['', [Validators.required]],
      seo_description: ['', [Validators.required]],
      seo_keywords: ['', [Validators.required]],
      status: ['InActive', [Validators.required]],
      publish_date_and_timer: ['', []],
    });
    try {
      // getting the available eseries from the database
      this.comicService.getWISSeasons().then(eseriesdata => {
        // subscribing the data from the service
        eseriesdata.subscribe(WISseasons => {
          this.Wisseasons = WISseasons;
            this.route.params.subscribe(params => {
              this.id = params['id'];
              if (this.id) {
                this.status = false;
                this.showseries = false;
                this.showseason = false;
                this.chapterno = false;
                this.comicService.getsinglenovel(this.id, 'WISEpisodes').then(chapterdata => {
                  chapterdata.subscribe(singlechapter => {
                    this.singlechapter = singlechapter;
                        this.WISEpisodeForm.get('season_id').setValue(singlechapter['season_id']);
                        this.WISEpisodeForm.get('shortstory_title').setValue(singlechapter['shortstory_title']);
                        this.WISEpisodeForm.get('shortstory_no').setValue(singlechapter['shortstory_no']);
                        this.WISEpisodeForm.get('story_description').setValue(singlechapter['story_description']);
                        this.WISEpisodeForm.get('thumbnail_image').setValue(singlechapter['thumbnail_image']);
                        this.WISEpisodeForm.get('thumbnail_app').setValue(singlechapter['thumbnail_app']);
                        this.WISEpisodeForm.get('cover_image').setValue(singlechapter['cover_image']);
                        this.WISEpisodeForm.get('hits').setValue(singlechapter['hits']);
                        this.WISEpisodeForm.get('seo_url').setValue(singlechapter['seo_url']);
                        this.WISEpisodeForm.get('seo_title').setValue(singlechapter['seo_title']);
                        this.WISEpisodeForm.get('seo_description').setValue(singlechapter['seo_description']);
                        this.WISEpisodeForm.get('seo_keywords').setValue(singlechapter['seo_keywords']);
                        this.WISEpisodeForm.get('status').setValue(singlechapter['status']);
                        const date = singlechapter['publish_date_and_timer']?new Date(singlechapter['publish_date_and_timer'].seconds*1000):''
                        this.WISEpisodeForm.get('publish_date_and_timer').setValue(date);
                        this.cover_image_url = singlechapter['cover_image'];
                        this.thumbnail_image_url = singlechapter['thumbnail_image'];
                        this.thumbnail_image_url_app = singlechapter['thumbnail_app'];
                        this.status = true;
                        this.showseries = true;
                        this.showseason = true;
                        this.chapterno = true;
                      });
                });
              }else{
                
            this.getnovelseasons(this.Wisseasons[0].id);
            console.log('asdfdfs')
            this.showseason = true;
            if (!this.id) {
              this.auth.getuser().then(userdetails => {
                this.user = userdetails;
              });
            }
              }
            });
   

        });
      });

    } catch (error) {
      console.log(error);
    }
  }

  async addchapter(value, valid) {
    if (valid) {
      await this.comicService.checkchapter(value.season_id, value.shortstory_no).then(async chapter => {
        if (chapter) {
          if (!this.id) {
            this.toastr.error('The chapter is already added!', 'Oops!');
            return true
          } else if (value.chapter_no != this.singlechapter.chapter_no) {
            this.toastr.error('The chapter is already added!', 'Oops!');
            return true
          }
        }
        this.loading = true;
        var story_description = value.story_description.replace(/&lt;br&gt;/g,'<br>')
        const season: Chapter = {
          season_id: value.season_id,
          shortstory_title: value.shortstory_title,
          story_description: story_description,
          shortstory_no: value.shortstory_no,
          shortstory_number: parseInt(value.shortstory_no.slice(3)),
          hits: value.hits,
          seo_url: value.seo_url,
          seo_title: value.seo_title,
          seo_description: value.seo_description,
          seo_keywords: value.seo_keywords,
          status: value.status,
          publish_date_and_timer: value.publish_date_and_timer?new Date(value.publish_date_and_timer):'',
          publish_date_and_time: value.publish_date_and_timer?new Date(value.publish_date_and_timer):'',
        };
        try {
          if (this.id) {
            let thumbnail;
            let thumbnail_app;
            let coverimage;
            // Checking if the cover image is changed if changed the update the image in sapces and also db.
            if (this.cover_image) {
              coverimage = await this.auth.uploadimage('wis/cover/', this.cover_image, false);
              season.cover_image = coverimage['Location'];
            }
            // Checking if the thumbnail image is changed if changed the update the image in sapces and also db.
            if (this.thumbnail_image) {
              thumbnail = await this.auth.uploadimage('wis/thumbnail/', this.thumbnail_image, false);
              season.thumbnail_image = thumbnail['Location'];
            }
            if (this.thumbnail_image_app) {
              thumbnail_app = await this.auth.uploadimage('wis/thumbnail/', this.thumbnail_image_app, false);
              season.thumbnail_app = thumbnail['Location'];
            }
            const document = await this.afs.doc(`/WISEpisodes/${this.id}`);
            const update = await document.update(season);
            this.toastr.success('WIS episode Updated!', 'Success!');
            setTimeout(() => {
              this.router.navigate(['/wis-episodes']);
            }, 2000);
          } else {
            if (!this.thumbnail_image) { this.thumbnailimageerror = true; this.loading = false; return false; }
            if (!this.thumbnail_image_app) { this.thumbnailimageerror_App = true; this.loading = false; return false; }
            if (!this.cover_image) { this.coverimageerror = true; this.loading = false; return false; }
            // uploading the images to the spaces and getting the uoloaded location
            const thumbnail = await this.auth.uploadimage('wis/thumbnail/', this.thumbnail_image, false);
            const thumbnail_app = await this.auth.uploadimage('wis/thumbnail/', this.thumbnail_image_app, false);
            const coverimage = await this.auth.uploadimage('wis/cover/', this.cover_image, false);
            const updatereads = await this.afs.doc('WISSeason/' + value.season_id).update({ reads: this.reads + parseInt(value.hits) })
            season.thumbnail_image = thumbnail['Location'];
            season.cover_image = coverimage['Location'];
            season.thumbnail_app = thumbnail_app['Location'];
            season.admin = this.user.uid;
            season.addedby = this.user.username;
            season.createdAt = new Date();
            season.date = new Date().toString();
            season.season_title = this.selectedseason.season_title;
            season.wis_season = this.selectedseason.season;
            const eseasondata = await this.afs.collection('WISEpisodes').add(season);
            const esid = eseasondata.id;
            const id = await this.afs.doc(`/WISEpisodes/${esid}`).update({ id: esid });
            this.toastr.success('WIS Episode Added!', 'Success!');
            setTimeout(() => {
              this.router.navigate(['/wis-episodes']);
            }, 2000);
          }
        } catch (error) {
          this.loading = false;
          this.load = true;
        }
      })
    } else {
      console.log('error');
    }
  }
  async setseason(id) {
    const singleseason = await this.afs.doc('/WISSeason/' + id);
    const data = singleseason.valueChanges();
    data.subscribe(season => {
      this.selectedseason = season;
      this.reads = parseInt(season['reads']);
    });
    return true;
  }

  async getnovelseasons(id) {
    this.showseason = false;
    try {
      await this.comicService.getsinglenovel(id, 'WISSeason').then(eseasonsdata => {
        // subscribing the data from the service
        eseasonsdata.subscribe((eseasons:any) => {
          var selected = eseasons;
          if (selected.id) {
           this.WISEpisodeForm.controls["season_id"].setValue(selected.id);
            this.setseason(selected.id);
          }
          console.log('sadfa');

          this.showseason = true;
        });
      });
    } catch (error) {
      this.showseason = true;
      console.log(error);
    }
  }


  changeListner1(event) {
    this.thumbnailimageerror = false;
    if (event.target.files && event.target.files[0]) {
      this.thumbnail_image = event.target.files[0];
      var reader = new FileReader();

      reader.onload = (event: any) => {
        this.thumbnail_image_url = event.target.result;
      }

      reader.readAsDataURL(event.target.files[0]);
    }
  }

  changeListner3(event) {
    this.thumbnailimageerror_App = false;
    if (event.target.files && event.target.files[0]) {
      this.thumbnail_image_app = event.target.files[0];
      var reader = new FileReader();

      reader.onload = (event: any) => {
        this.thumbnail_image_url_app = event.target.result;
      }

      reader.readAsDataURL(event.target.files[0]);
    }
  }

  changeListner2(event) {
    this.coverimageerror = false;
    if (event.target.files && event.target.files[0]) {
      this.cover_image = event.target.files[0];
      var reader = new FileReader();

      reader.onload = (event: any) => {
        this.cover_image_url = event.target.result;
      }

      reader.readAsDataURL(event.target.files[0]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/wis/wis-episode-add/wis-episode-add.component.ts